import React from 'react';

const TestimonialCard = ({ quote, callToAction, className }) => {
  return (
    <div
      className="hidden lg:flex w-full lg:w-1/2 items-center justify-center"
      style={{
        background: 'linear-gradient(to right, rgba(41, 98, 255, 0.1), rgba(0, 0, 0, 0))'
      }}
    >
      <div className="w-full max-w-xl p-4 sm:p-6">
        <div className="relative">
          <div className="text-5xl opacity-50 absolute -top-16 left-0 font-serif">"</div>
          <div className="mt-6">
            <blockquote className="text-2xl md:text-3xl font-medium text-gray-800 mb-10 text-center">
              "This app prints me money! I found out why people weren't buying, and the AI chatbot closed the sale on the spot—it's just insane!"
            </blockquote>
            <div className={`bg-white rounded-lg shadow-lg p-8 w-[480px] max-w-full mx-auto ${className || ''}`}>
              <div className="flex flex-col space-y-6">
                <div className="text-5xl font-serif text-center">"</div>
                <p className="text-xl font-medium text-gray-800 text-center">{quote}</p>
                <div className="flex justify-center">
                  <button className="text-blue-500 hover:text-blue-600 font-medium transition-colors duration-200">
                    {callToAction}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
